(function () {
  const ready = (fn) => {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  };

  ready(() => {
    const toggle = document.querySelector("[data-menu-toggle]");
    const mobileNav = document.querySelector("[data-mobile-nav]");
    if (toggle && mobileNav) {
      toggle.addEventListener("click", () => {
        const open = mobileNav.classList.toggle("is-open");
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }

    document.querySelectorAll("[data-qty-minus], [data-qty-plus]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const input = btn.parentElement.querySelector('input[type="number"]');
        if (!input) return;
        const step = Number(input.step || 1);
        const min = Number(input.min || 1);
        const max = Number(input.max || 99);
        let val = Number(input.value || min);
        if (btn.hasAttribute("data-qty-minus")) val = Math.max(min, val - step);
        if (btn.hasAttribute("data-qty-plus")) val = Math.min(max, val + step);
        input.value = String(val);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
    });

    const galleryMain = document.querySelector("[data-gallery-main]");
    document.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
      thumb.addEventListener("click", () => {
        if (!galleryMain) return;
        const src = thumb.getAttribute("data-src");
        const alt = thumb.getAttribute("data-alt") || "";
        if (src) {
          galleryMain.src = src;
          galleryMain.alt = alt;
        }
      });
    });

    // Variant picker for product forms with select[name=id]
    const variantSelect = document.querySelector("[data-variant-select]");
    const priceEl = document.querySelector("[data-product-price]");
    if (variantSelect && priceEl) {
      variantSelect.addEventListener("change", () => {
        const opt = variantSelect.selectedOptions[0];
        if (!opt) return;
        const price = opt.getAttribute("data-price");
        const available = opt.getAttribute("data-available") === "true";
        if (price) priceEl.innerHTML = price;
        const submit = document.querySelector("[data-add-to-cart]");
        if (submit) {
          submit.disabled = !available;
          submit.textContent = available ? submit.getAttribute("data-label-add") || "Add to cart" : "Sold out";
        }
      });
    }
  });
})();
